import { TPosition, TPositionOffset } from '_c/typings/model/position';

/**
 * 获取在可视区域的正确位置信息
 * @param position 原始位置信息
 * @param positionOffset 位置的偏移纠正值
 * @returns 在可视区域的正确位置信息
 */
export function getInViewPosition(
  position: TPosition,
  positionOffset?: TPositionOffset,
): TPosition {
  const defaultOffset = 10;
  const { x, y, width, height } = position;
  const { clientWidth, clientHeight } = document.body;
  const { offsetX = 0, offsetY = 0, offsetWidth = 0, offsetHeight = 0 } = positionOffset || {};
  const defaultX = clientWidth - width - defaultOffset - offsetX - offsetWidth;
  const defaultY = clientHeight - height - defaultOffset - offsetY - offsetHeight;
  // 1.右下边界碰撞检查
  let formatX = Math.min(x - offsetX, defaultX);
  let formatY = Math.min(y - offsetY, defaultY);
  // 2.左上边界碰撞检查
  formatX = Math.max(formatX, 0);
  formatY = Math.max(formatY, 0);

  return {
    x: formatX,
    y: formatY,
    width,
    height,
  };
}
